import type { GatheringKind } from '@/components/programs/gathering-schedule';

export type CalendarOccurrenceStub = {
  id: string;
  occurrenceDate: string;
  startsAt: string;
  endsAt: string;
};

export type CalendarStreamItem = {
  id: string;
  programId: string;
  programName: string;
  programKind: GatheringKind;
  programStartsOn: string | null;
  programEndsOn: string | null;
  programStartsAt: string | null;
  programEndsAt: string | null;
  venueName: string | null;
  dates: string[];
  occurrences?: CalendarOccurrenceStub[];
  isActive: boolean;
  gpsAutoCheckInEnabled?: boolean;
};

/** Same indexing the calendar page uses to place items on each day cell. */
export const indexProgramsByDate = (
  items: CalendarStreamItem[],
): Map<string, CalendarStreamItem[]> => {
  const map = new Map<string, CalendarStreamItem[]>();
  for (const item of items) {
    for (const date of item.dates) {
      const list = map.get(date) ?? [];
      if (!list.some((row) => row.programId === item.programId)) {
        list.push(item);
      }
      map.set(date, list);
    }
  }
  for (const list of map.values()) {
    list.sort((a, b) => a.programName.localeCompare(b.programName));
  }
  return map;
};

export const calendarItemsForDate = (
  items: CalendarStreamItem[],
  date: string,
): CalendarStreamItem[] => indexProgramsByDate(items).get(date) ?? [];

export const occurrenceStubForDate = (
  item: CalendarStreamItem,
  date: string,
): CalendarOccurrenceStub | undefined =>
  item.occurrences?.find((row) => row.occurrenceDate === date);
